import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";
import { Box, Button, Dialog } from "@mui/material";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import image from "../../assets/trasporeon-new-features.jpg";

const LOCAL_STORAGE_KEY = "newFeatures06112025";

export const PromotionDialog = () => {
	const { t } = useTranslation();
	const [openPromotionPopup, setOpenPromotionPopup] = useState(false);

	// lock close button for 4 seconds
	const [lockCloseButton, setLockCloseButton] = useState(true);
	const [lockCounter, setLockCounter] = useState(4);

	// unlock button after 4 seconds
	useEffect(() => {
		if (lockCounter === 0) {
			setLockCloseButton(false);
			return;
		}

		const interval = setInterval(() => {
			setLockCounter((prev) => prev - 1);
		}, 1000);

		return () => clearInterval(interval);
	}, [lockCounter]);

	// show promotion popup only if today is the same or after the promotion date
	useEffect(() => {
		if (localStorage.getItem(LOCAL_STORAGE_KEY) !== "true") {
			setOpenPromotionPopup(true);
			localStorage.setItem(LOCAL_STORAGE_KEY, "true");
		}
	}, []);

	return (
		<Dialog
			fullWidth
			maxWidth="md"
			onClose={(_e, reason) => {
				if (reason === "backdropClick") return;
				setOpenPromotionPopup(false);
			}}
			open={openPromotionPopup}
			disableEscapeKeyDown={true}
		>
			<Box sx={{ padding: "30px" }}>
				<Box sx={{ position: "relative" }}>
					<img style={{ width: "100%" }} src={image} alt="" />
					<Box
						sx={{
							width: "100%",
							position: "absolute",
							right: "30px",
							bottom: "20px",
							display: "flex",
							justifyContent: "center",
							gap: "20px",
						}}
					>
						<Button
							variant="contained"
							href="https://youtu.be/yYJDlVEtYvM"
							target="_blank"
							rel="noreferrer"
							sx={{
								background: "linear-gradient(to right, #ff852e, #ff5785)",
								color: "#fff",
								display: "flex",
								alignItems: "center",
								gap: "4px",
							}}
						>
							<SlowMotionVideoIcon />
							{t("video_instruction_n_min", { value: 5 })}
						</Button>
						<Button
							variant="contained"
							color="error"
							disabled={lockCloseButton}
							onClick={() => setOpenPromotionPopup(false)}
							sx={{
								textTransform: "uppercase",
								background: "#585858",
								"&:hover": {
									background: "#474646",
								},
							}}
						>
							{t("close")} {lockCounter > 0 && `(${lockCounter})`}
						</Button>
					</Box>
				</Box>
			</Box>
		</Dialog>
	);
};
